// Mensagens customizadas para o Pristine
Pristine.addMessages('en', {
   required: 'Este campo é obrigatório.',
   email: 'Por favor, forneça um endereço de e-mail válido.',
   number: 'Por favor, forneça um número válido.',
   integer: 'Por favor, forneça apenas dígitos.',
   url: 'Por favor, forneça um URL válido.',
   tel: 'Por favor, forneça um número de telefone válido.',
   maxlength: 'Por favor, forneça menos do que ${1} caracteres.',
   minlength: 'Por favor, forneça mais do que ${1} caracteres.',
   min: 'O valor mínimo para este campo é de ${1}.',
   max: 'O valor máximo para este campo é de ${1}.',
   pattern: 'Por favor, forneça uma informação de acordo com o formato do campo.',
   equals: 'Os dois campos não correspondem.',
   default: 'Por favor, forneça um valor válido.',
});

Pristine.addValidator(
   'cnpj',
   value => {
      return cnpjValidation(value);
   },
   'Por favor, forneça um CNPJ válido.',
   2,
   false
);

Pristine.addValidator(
   'cpf',
   value => {
      return cpfValidation(value);
   },
   'Por favor, forneça um CPF válido.',
   2,
   false
);

function cnpjValidation(value) {
   if (!value) return false;

   // Aceita receber o valor como string, número ou array com todos os dígitos
   const isString = typeof value === 'string';
   const validTypes = isString || Number.isInteger(value) || Array.isArray(value);

   // Elimina valor em formato inválido
   if (!validTypes) return false;

   // Filtro inicial para entradas do tipo string
   if (isString) {
      // Limita ao máximo de 18 caracteres, para CNPJ formatado
      if (value.length > 18) return false;

      const stripped = value.replace(/[^a-zA-Z0-9]/g, '');
      if (stripped.length !== 14) return false;

      // CNPJ alfanumérico: aceita se tiver letras e exatamente 14 caracteres alfanuméricos
      if (!/^\d+$/.test(stripped)) return true;

      // Teste Regex para veificar se é uma string apenas dígitos válida
      const digitsOnly = /^\d{14}$/.test(value);
      // Teste Regex para verificar se é uma string formatada válida
      const validFormat = /^\d{2}.\d{3}.\d{3}\/\d{4}-\d{2}$/.test(value);

      // Se o formato é válido, usa um truque para seguir o fluxo da validação
      if (digitsOnly || validFormat) return true;
      // Se não, retorna inválido
      else return false;
   }

   // Guarda um array com todos os dígitos do valor
   const match = value.toString().match(/\d/g);
   const numbers = Array.isArray(match) ? match.map(Number) : [];

   // Valida a quantidade de dígitos
   if (numbers.length !== 14) return false;

   // Elimina inválidos com todos os dígitos iguais
   const items = [...new Set(numbers)];
   if (items.length === 1) return false;

   // Cálculo validador
   const calc = x => {
      const slice = numbers.slice(0, x);
      let factor = x - 7;
      let sum = 0;

      for (let i = x; i >= 1; i--) {
         const n = slice[x - i];
         sum += n * factor--;
         if (factor < 2) factor = 9;
      }

      const result = 11 - (sum % 11);

      return result > 9 ? 0 : result;
   };

   // Separa os 2 últimos dígitos de verificadores
   const digits = numbers.slice(12);

   // Valida 1o. dígito verificador
   const digit0 = calc(12);
   if (digit0 !== digits[0]) return false;

   // Valida 2o. dígito verificador
   const digit1 = calc(13);
   return digit1 === digits[1];
}

function cpfValidation(value) {
   if (!value) return false;

   // Aceita receber o valor como string, número ou array com todos os dígitos
   const validTypes = typeof value === 'string' || Number.isInteger(value) || Array.isArray(value);

   // Elimina valores com formato inválido
   if (!validTypes) return false;

   // Guarda todos os dígitos em um array
   const numbers = value.toString().match(/\d/g).map(Number);

   // Valida quantidade de dígitos
   if (numbers.length !== 11) return false;

   // Elimina valores inválidos com todos os dígitos repetidos
   const items = [...new Set(numbers)];
   if (items.length === 1) return false;

   // Separa número base do dígito verificador
   const base = numbers.slice(0, 9);
   const digits = numbers.slice(9);

   // Cálculo base
   const calc = (n, i, x) => n * (x - i);

   // Utilitário de soma
   const sum = (r, n) => r + n;

   // Cálculo de dígito verificador
   const digit = n => {
      const rest = n % numbers.length;
      return rest < 2 ? 0 : numbers.length - rest;
   };

   // Cálculo sobre o número base
   const calc0 = base.map((n, i) => calc(n, i, numbers.length - 1)).reduce(sum, 0);
   // 1o. dígito verificador
   const digit0 = digit(calc0);

   // Valida 1o. digito verificador
   if (digit0 !== digits[0]) return false;

   // Cálculo sobre o número base + 1o. dígito verificador
   const calc1 = base
      .concat(digit0)
      .map((n, i) => calc(n, i, numbers.length))
      .reduce(sum, 0);
   // 2o. dígito verificador
   const digit1 = digit(calc1);

   // Valida 2o. dígito verificador
   return digit1 === digits[1];
}

let btnMenuMobile = false;
const menuController = {
   isDesktop: null,
   eventType: null,

   init(isDesktop, eventType) {
      this.isDesktop = isDesktop;
      this.eventType = eventType;

      // Menu padrão
      if (this.isDesktop) {
         this.openMenu();
         this.searchDesktop();
      } else {
         this.openMenuMobile();
         this.searchMobile();
      }

      this.openSubMenu();

      // Menu área (cliente e parceiro)
      this.openMenuArea();
      this.openSubMenuArea();

      // Fecha o menu quando clica em qualquer lugar da página fora do container.
      this.closeMenu();

      // Abre painel de pesquisa
      // this.searchMobile();
      // this.searchDesktop();
   },

   openMenu() {
      let btnMenu = true;
      const btnOpenMenu = document.querySelectorAll('.js-open-menu');
      const allMenuContainer = document.querySelectorAll('.js-menu-container');

      btnOpenMenu.forEach(button => {
         button.addEventListener(this.eventType, ({ currentTarget }) => {
            let siblingElement = currentTarget.nextElementSibling;
            let hasContainer = siblingElement.classList.contains('js-menu-container');

            // EM DESKTOP, PERMITE SOMENTE UM CONTAINER DE MENU ABERTO POR VEZ.
            allMenuContainer.forEach(containerMenu => {
               if (siblingElement !== containerMenu) {
                  containerMenu.classList.remove('open');
               }
            });
            if (btnMenu) {
               siblingElement.classList.add('open');
               btnMenu = false;
            } else {
               siblingElement.classList.remove('open');
               btnMenu = true;
            }

            if (siblingElement.classList.contains('open')) {
               currentTarget.setAttribute('aria-expanded', 'true');
            } else {
               currentTarget.setAttribute('aria-expanded', 'false');
            }
         });
      });

      btnOpenMenu.forEach(button => {
         button.addEventListener('mouseout', ({ currentTarget }) => {
            const siblingElement = currentTarget.nextElementSibling;
            const hasContainer = siblingElement.classList.contains('open');
            // EM DESKTOP, PERMITE SOMENTE UM CONTAINER DE MENU ABERTO POR VEZ.
            allMenuContainer.forEach(containerMenu => {
               if (siblingElement !== containerMenu) {
                  containerMenu.classList.remove('open');
               }
            });
            if (!btnMenu) {
               siblingElement.classList.remove('open');
               btnMenu = true;
            }
            if (siblingElement.classList.contains('open')) {
               currentTarget.setAttribute('aria-expanded', 'true');
            } else {
               currentTarget.setAttribute('aria-expanded', 'false');
            }
         });
      });
      allMenuContainer.forEach(container => {
         container.addEventListener('mouseover', ({ currentTarget }) => currentTarget.classList.add('open'));
      });
      allMenuContainer.forEach(container => {
         container.addEventListener('mouseout', ({ currentTarget }) => currentTarget.classList.remove('open'));
      });
   },

   openMenuMobile() {
      const btnOpenMenu = document.querySelectorAll('.js-open-menu');
      const allMenuContainer = document.querySelectorAll('.js-menu-container');

      btnOpenMenu.forEach(button => {
         button.addEventListener(this.eventType, ({ currentTarget }) => {
            let siblingElement = currentTarget.nextElementSibling;

            allMenuContainer.forEach(containerMenu => {
               if (siblingElement !== containerMenu) {
                  containerMenu.classList.remove('open');
               } else {
                  if (currentTarget.getAttribute('aria-expanded', 'true') && siblingElement.classList.contains('open')) {
                     btnMenuMobile = true;
                  } else {
                     siblingElement.classList.add('open');
                     containerMenu.classList.add('open');
                     btnMenuMobile = false;
                  }
               }
            });

            if (!btnMenuMobile) {
               siblingElement.classList.add('open');
               btnMenuMobile = true;
            } else {
               siblingElement.classList.remove('open');
               btnMenuMobile = false;
            }

            if (siblingElement.classList.contains('open')) {
               currentTarget.setAttribute('aria-expanded', 'true');
            } else {
               currentTarget.setAttribute('aria-expanded', 'false');
            }
         });
      });
   },

   openSubMenu() {
      const subMenuTitle = document.querySelectorAll('.nav-menu__submenu-item--title');

      setTimeout(() => {
         const subMenuLink = document.querySelectorAll('li.header__submenu-item > a');
         subMenuLink.forEach(link => {
            if (link.href.substring(link.href.length, link.href.length - 3) == 'pdf') {
               link.setAttribute('target', '_blank');
            }
         });
      }, 1000);

      subMenuTitle.forEach(eachElement => {
         eachElement.addEventListener('click', ({ target }) => {
            let grandParentEl = '';

            if (target.classList.contains('accordion-arrow')) {
               target.classList.toggle('accordion-arrow--active');
               grandParentEl = target.parentElement.parentElement.parentElement;
            } else {
               target.children[0].classList.toggle('accordion-arrow--active');
               grandParentEl = target.parentElement.parentElement;
            }

            for (const element of grandParentEl.children) {
               if (element !== subMenuTitle) {
                  element.classList.toggle('open');
               }
            }
         });
      });
   },

   openMenuArea() {
      const subMenuTitle = document.querySelectorAll('.header__submenu-item--title');
      subMenuTitle.forEach(eachElement => {
         eachElement.addEventListener('click', ({ target }) => {
            let grandParentEl = '';

            if (target.classList.contains('accordion-arrow')) {
               grandParentEl = target.parentElement.parentElement.parentElement;
            } else {
               grandParentEl = target.parentElement.parentElement;
            }

            if (target.classList.contains('accordion-arrow')) {
               target.classList.toggle('accordion-arrow--active');
            } else {
               target.children[0].classList.toggle('accordion-arrow--active');
            }

            for (const element of grandParentEl.children) {
               if (element !== subMenuTitle && !element.classList.contains('header__submenu-item--third-level')) {
                  element.classList.toggle('open');
               }
            }
         });
      });
   },

   openSubMenuArea() {
      const openMenuList = document.querySelectorAll('.header__submenu-item--third-level-open button');

      openMenuList.forEach(eachElement => {
         eachElement.addEventListener('click', ({ target }) => {
            let siblingElement = '';
            let childrenElement = '';

            if (target.classList.contains('accordion-arrow-third-level')) {
               siblingElement = target.parentElement.nextElementSibling;
               childrenElement = target;
            } else {
               siblingElement = target.nextElementSibling;
               childrenElement = target.children[0];
            }

            childrenElement.classList.toggle('accordion-arrow-third-level--active');

            for (const element of siblingElement.children) {
               if (element.classList.contains('header__submenu-item--third-level')) {
                  element.classList.toggle('open');
               }
            }

            if (childrenElement.classList.contains('accordion-arrow-third-level--active')) {
               target.setAttribute('aria-expanded', 'true');
            } else {
               target.setAttribute('aria-expanded', 'false');
            }
         });
      });
   },

   closeMenu() {
      const elementsToMatch = [
         '.js-open-menu',
         '.header__submenu-item--third-level-open > button',
         'nav-menu__submenu-item--title > button',
         '.accordion-arrow-third-level',
      ];

      document.addEventListener('click', ({ target }) => {
         if (!target.matches(elementsToMatch) && this.isDesktop) {
            const allMenuContainer = document.querySelectorAll('.js-menu-container');
            allMenuContainer.forEach(container => {
               if (container.classList.contains('open')) {
                  container.classList.remove('open');
               }
            });
         }
      });
   },

   searchMobile() {
      const button = document.querySelector('.header__search-btn-mobile');
      const checkboxMenu = document.querySelector('.hamburger-menu__checkbox');
      const searchContainer = document.querySelector('.header__nav-search-mobile');
      const headerLogo = document.querySelector('.header__logo');
      const searchTitle = document.querySelector('.header__search-title-mobile');
      const itemsSubMenu = document.querySelector('nav.nav-menu');

      //para o menu de busca sempre iniciar fechado
      window.addEventListener('pageshow', () => {
         if(checkboxMenu) {
            checkboxMenu.checked = false;
         };
         if(itemsSubMenu) {
            itemsSubMenu.style.display = 'flex';
         };
         if(searchContainer) {
            searchContainer.classList.remove('header__nav-search-mobile--open');
         };
         if(button) {
            button.style.display = 'none';
         };
         if(searchTitle) {
            searchTitle.style.display = 'none';
         };
         if(headerLogo) {
            headerLogo.style.display = 'block';
         };
      });

      if (button) {
         button.addEventListener('click', () => {
            searchContainer.classList.toggle('header__nav-search-mobile--open');

            if (document.querySelector('.header__nav-search-mobile--open')) {
               itemsSubMenu.style.display = 'none';
               headerLogo.style.display = 'none';
               searchTitle.style.display = 'block';
            } else {
               itemsSubMenu.style.display = 'block';
               headerLogo.style.display = 'block';
               searchTitle.style.display = 'none';
            }
         });
      }

      if (checkboxMenu) {
         checkboxMenu.addEventListener('click', () => {
            searchTitle.style.display = 'none';
            headerLogo.style.display = 'block';
            button.style.display = 'flex';
            itemsSubMenu.style.display = 'block';

            if (!checkboxMenu.checked) {
               searchContainer.classList.remove('header__nav-search-mobile--open');
               button.style.display = 'none';

               this.closeAllMenuMobile();
            }
         });
      }
   },

   searchDesktop() {
      const checkbox = document.querySelector('.hamburger-menu-search__checkbox');
      const ul = document.querySelector('.nav-menu > ul');
      const header = document.querySelector('.search-results__form--header');

      //para o menu de busca sempre iniciar fechado
      window.addEventListener('pageshow', () => {
         if(checkbox) {
            checkbox.checked = false;
         };
         if(ul) {
            ul.style.display = 'flex';
         };
         if(header) {
            header.style.display = 'none';
         };
      });

      if (checkbox) {
         checkbox.addEventListener('click', () => {
            if (checkbox.checked) {
               ul.style.display = 'none';
               header.style.display = 'flex';
            } else {
               ul.style.display = 'flex';
               header.style.display = 'none';
            }
         });
      }
   },

   closeAllMenuMobile() {
      if (document.querySelector('#buscaPalavra')) {
         document.getElementById('buscaPalavra').value = '';
      }

      document.querySelectorAll('.header__nav > nav.nav-menu .open').forEach(function (el) {
         el.classList.remove('open');
      });

      document.querySelectorAll('[aria-expanded=true]').forEach(function (el) {
         el.setAttribute('aria-expanded', 'false');
      });

      document.querySelectorAll("span[class*='--active']").forEach(function (el) {
         const namesClass = el.className.split(' ');
         namesClass.forEach(function (name) {
            if (name.includes('--active')) el.classList.remove(name);
         });
      });
   },
};

function menuAnchorLP() {
   const anchorItens = document.querySelectorAll('a.nav-menu-lp__item');
   const humburger = document.querySelector('input#hamburger-menu-lp');
   if (humburger) {
      humburger.checked = false;
   }

   anchorItens.forEach(item => {
      item.addEventListener('click', () => {
         humburger.checked = false;
      });
   });
}

// Background-color do footer igual ao da última section da página.
function setFooterBgColor() {
   const sections = document.querySelectorAll('section');
   const footer = document.querySelector('footer.footer');

   // Verificar se existe pelo menos uma section
   if (sections.length === 0) {
      return; // Sai da função se não houver sections
   }

   const lastSection = sections[sections.length - 1];
   const lastSectionBgColor = getComputedStyle(lastSection).backgroundColor;

   if (footer) {
      footer.style.backgroundColor = lastSectionBgColor;
   }
}

// Color do cantainer do footer de acordo com a classe escolhida pela div parametrizadora.
function setFooterContainerColor() {
   const paramClassName = document.querySelector('div#param-footer-color');
   const footerCustom = document.querySelector('footer.footer div.footer__custom');
   if (paramClassName && footerCustom) {
      footerCustom.classList.add(paramClassName.className);
   }
}

/*  O header é fixo e a tag main possui uma margin-top. 
Com isso ao clicar no menu de âncoras, o elemento com o id correspondente não 
fica totalmente visível na tela. A função abaixo foi criada para solucionar esse problema. */
function scrollToElement(elementId) {
   const element = document.getElementById(elementId);
   const elementPosition = element.getBoundingClientRect().top;
   const offsetPosition = elementPosition + window.pageYOffset;
   const headerHeight = document.querySelector('header.header').offsetHeight;
   const scrollTo = offsetPosition - headerHeight;

   window.scrollTo({
      top: scrollTo,
      behavior: 'smooth',
   });
}

const anchors = document.querySelectorAll('a[href^="#"][class$="__pointer"]');

if (document.querySelector('header.header')) {
   anchors.forEach(anchor => {
      anchor.addEventListener('click', function (e) {
         e.preventDefault();
         const elementId = this.getAttribute('href').substring(1);
         scrollToElement(elementId);
      });
   });
}

let isMobile = false;
window.onload = function () {
   if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      isMobile = true;
   }
};

function mobileTelefone(numero) {
   if (isMobile) {
      window.location.href = numero;
   }
}

function redimensionouTela() {
   menuController.closeAllMenuMobile();
   const isDesktop = window.innerWidth >= 1200 || navigator.userAgent.indexOf('Mobi') === -1;
   const eventType = isDesktop ? 'mouseover' : 'click';
   menuController.init(isDesktop, eventType);
}

function sliderAutoPlay() {
   const carousels = document.querySelectorAll('.glider-autoplay');

   window.addEventListener('load', function () {
      for (const carousel of carousels) {
         const glider = new Glider(carousel);

         function sliderAuto(slider, miliseconds) {
            const slidesCount = slider.track.childElementCount;
            let slideTimeout = null;
            let nextIndex = 1;

            function slide() {
               slideTimeout = setTimeout(function () {
                  if (nextIndex >= slidesCount) {
                     nextIndex = 0;
                  }
                  slider.scrollItem(nextIndex++);
               }, miliseconds);
            }

            slider.ele.addEventListener('glider-animated', function () {
               window.clearInterval(slideTimeout);
               slide();
            });

            slide();
         }

         sliderAuto(glider, 7000);
      }
   });
}

// menuController.init();
redimensionouTela();
menuAnchorLP();
setFooterBgColor();
setFooterContainerColor();
sliderAutoPlay();

//está bugando o site, verificar fc
// window.addEventListener('resize', () => {
//    location.reload();
// });
